export const UPDATE_PROPERTY_INPUT = "UPDATE_PROPERTY_INPUT";
export const UPDATE_PROPERTY_INPUT_BULK = "UPDATE_PROPERTY_INPUT_BULK";
export const REQUEST_PROPERTY_CALC = "REQUEST_PROPERTY_CALC";
export const RECEIVE_PROPERTY_CALC = "RECEIVE_PROPERTY_CALC";
export const UI_TOGGLE_BOOLEAN = "UI_TOGGLE_BOOLEAN";
export const CHANGE_WIZARD_STEP = "CHANGE_WIZARD_STEP";


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/PropertyActionTypes.jsx